import { render, staticRenderFns } from "./ActivityLogs.vue?vue&type=template&id=c788280e&scoped=true&"
import script from "./ActivityLogs.vue?vue&type=script&lang=js&"
export * from "./ActivityLogs.vue?vue&type=script&lang=js&"
import style0 from "./ActivityLogs.vue?vue&type=style&index=0&id=c788280e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c788280e",
  null
  
)

/* custom blocks */
import block0 from "./ActivityLogs.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c788280e')) {
      api.createRecord('c788280e', component.options)
    } else {
      api.reload('c788280e', component.options)
    }
    module.hot.accept("./ActivityLogs.vue?vue&type=template&id=c788280e&scoped=true&", function () {
      api.rerender('c788280e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/admin/ActivityLogs.vue"
export default component.exports